import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/mark/Documents/use-date-input-patch/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { useRef, useState } from 'react';
import { useDocs, Link, Playground } from 'docz';
import styled from "styled-components";
import { calendarActions, calendarReducer, createDateAPI, Calendar, CalendarProvider, Day, useCalendarDispatch, useCalendarState, singleDateReducer, Root } from "@use-date-input/core";
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { adapter as dateAdapter } from '@use-date-input/date-fns-adapter';
import getDay from "date-fns/getDay";
import eachDayOfInterval from "date-fns/eachDayOfInterval";
import sampleTheme from "../../stories/sampleTheme";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "state"
    }}>{`State`}</h1>
    <p><inlineCode parentName="p">{`use-date-input`}</inlineCode>{` comes with a set of default reducers which are composed together to create
the state for `}<inlineCode parentName="p">{`useDateInput`}</inlineCode>{`, `}<inlineCode parentName="p">{`useDateRangeInput`}</inlineCode>{` and `}<inlineCode parentName="p">{`Calender`}</inlineCode>{`.`}</p>
    <p>{`You can override the default state or add additional state, whatever your components need, with the `}<inlineCode parentName="p">{`reducers`}</inlineCode>{` prop.`}<br parentName="p"></br>{`
`}{`The `}<inlineCode parentName="p">{`reducers`}</inlineCode>{` prop can be provided to either `}<inlineCode parentName="p">{`CalendarProvider`}</inlineCode>{` or `}<inlineCode parentName="p">{`Calendar`}</inlineCode>{`.`}</p>
    <p>{`In this example we change the selection created by the default reducers, so that it adds 1 week to any date that is selected.`}<br parentName="p"></br>{`
`}{`Any part of the default state can be modified in this way.`}</p>
    <Playground __position={0} __code={'() => {\n  // import { Calendar, calendarReducer, calendarActions, singleDateReducer } from \"@use-date-input/core\";\n  // import { adapter as dateAdapter } from \"@use-date-input/date-fns-adapter\";\n  function handleStateChange(newState, changes) {\n    console.log(\'new state\', newState.startDate, changes)\n  }\n  const myReducer = (state, action, dateAPI) => {\n    if (action.type === calendarActions.selectDate) {\n      return { ...state, startDate: dateAPI.addWeeks(state.startDate, 1) }\n    }\n    return state\n  }\n  return (\n    <Calendar\n      adapter={dateAdapter}\n      reducers={[calendarReducer, singleDateReducer, myReducer]}\n      onStateChange={handleStateChange}\n    />\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      useRef,
      useState,
      useDocs,
      Link,
      Playground,
      styled,
      calendarActions,
      calendarReducer,
      createDateAPI,
      Calendar,
      CalendarProvider,
      Day,
      useCalendarDispatch,
      useCalendarState,
      singleDateReducer,
      Root,
      makeStyles,
      List,
      ListItem,
      ListItemText,
      dateAdapter,
      getDay,
      eachDayOfInterval,
      sampleTheme,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        // import { Calendar, calendarReducer, calendarActions, singleDateReducer } from "@use-date-input/core";
        // import { adapter as dateAdapter } from "@use-date-input/date-fns-adapter";
        function handleStateChange(newState, changes) {
          console.log('new state', newState.startDate, changes);
        }

        const myReducer = (state, action, dateAPI) => {
          if (action.type === calendarActions.selectDate) {
            return { ...state,
              startDate: dateAPI.addWeeks(state.startDate, 1)
            };
          }

          return state;
        };

        return <Calendar adapter={dateAdapter} reducers={[calendarReducer, singleDateReducer, myReducer]} onStateChange={handleStateChange} mdxType="Calendar" />;
      }}
    </Playground>
    <h2 {...{
      "id": "default-reducers"
    }}>{`Default Reducers`}</h2>
    <p>{`A brief description of the default reducers.`}</p>
    <h3 {...{
      "id": "calendarreducer"
    }}>{`calendarReducer`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { calendarReducer, calendarActions } from "@use-date-input/core";
`}</code></pre>
    <p>{`Creates the state for a stand-alone `}<inlineCode parentName="p">{`Calendar`}</inlineCode>{` with no associated input.  `}</p>
    <p>{`Associated actions :  `}</p>
    <ul>
      <li parentName="ul">{`focusDate - Focus a specific date`}</li>
      <li parentName="ul">{`keyPress - Keyboard action`}</li>
      <li parentName="ul">{`mouseClickOutside - Mouse clicked outside of Calendar (or allow list)`}</li>
      <li parentName="ul">{`navigatePrevious - Navigate to the previous month`}</li>
      <li parentName="ul">{`navigateNext - Navigate to the next month`}</li>
      <li parentName="ul">{`selectDate - Select a date (emulating keyboard or mouse selection)`}</li>
      <li parentName="ul">{`setAnimating - Create the transient state of animating between dates (used to prevent interim selection)`}</li>
      <li parentName="ul">{`setEnableKeyboardNavigation - Enable the navigation of the `}<inlineCode parentName="li">{`Calendar`}</inlineCode>{` cursor with the keyboard controls`}</li>
      <li parentName="ul">{`setEndDate - Create an end date for a date range (programatically)`}</li>
      <li parentName="ul">{`setFocusableDate - Enable/Disable focusable dates within the `}<inlineCode parentName="li">{`Calendar`}</inlineCode>{` `}</li>
      <li parentName="ul">{`setKeyboardCursor - Set the keyboard cursor within the `}<inlineCode parentName="li">{`Calendar`}</inlineCode>{` `}</li>
      <li parentName="ul">{`setMouseCursor - Set the mouse cursor within the `}<inlineCode parentName="li">{`Calendar`}</inlineCode>{` `}</li>
      <li parentName="ul">{`setStartDate - Create an start date for a date range (programatically)`}</li>
      <li parentName="ul">{`setOpen - Open the visible state of the `}<inlineCode parentName="li">{`Calendar`}</inlineCode></li>
      <li parentName="ul">{`setVisibleFromDate - Set the initial visible month`}</li>
    </ul>
    <h3 {...{
      "id": "singledatereducer"
    }}>{`singleDateReducer`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { singleDateReducer, calendarActions } from "@use-date-input/core";
`}</code></pre>
    <p>{`When combined with the `}<inlineCode parentName="p">{`singleDateReducer`}</inlineCode>{` it selects single dates.  `}</p>
    <p>{`Associated actions :  `}</p>
    <ul>
      <li parentName="ul">{`Uses the `}<inlineCode parentName="li">{`calendarReducer`}</inlineCode>{` actions`}</li>
    </ul>
    <h3 {...{
      "id": "daterangereducer"
    }}>{`dateRangeReducer`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { dateRangeReducer, calendarActions } from "@use-date-input/core";
`}</code></pre>
    <p>{`When combined with the `}<inlineCode parentName="p">{`calendarReducer`}</inlineCode>{` it selects a date range.   `}</p>
    <p>{`Associated actions :  `}</p>
    <ul>
      <li parentName="ul">{`Uses the `}<inlineCode parentName="li">{`calendarReducer`}</inlineCode>{` actions`}</li>
    </ul>
    <h3 {...{
      "id": "dateinputreducer"
    }}>{`dateInputReducer`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { dateInputReducer, dateInputActions } from "@use-date-input/core";
`}</code></pre>
    <p>{`Combines with `}<inlineCode parentName="p">{`calendarReducer`}</inlineCode>{` to select a single date from either the `}<inlineCode parentName="p">{`Calendar`}</inlineCode>{` or an input.`}</p>
    <p>{`Associated actions :  `}</p>
    <ul>
      <li parentName="ul">{`blurInput : Blur the associated input's focus`}</li>
      <li parentName="ul">{`focusInput : Focus the associated input`}</li>
      <li parentName="ul">{`focusLock : Enable/Disable the focus lock, so that tabbing behaviour links both input and `}<inlineCode parentName="li">{`Calendar`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "daterangeinputreducer"
    }}>{`dateRangeInputReducer`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { dateRangeInputReducer, dateRangeInputActions, dateRangeInputType } from "@use-date-input/core";
`}</code></pre>
    <p>{`Combines with `}<inlineCode parentName="p">{`calendarReducer`}</inlineCode>{` to select a date range from either the `}<inlineCode parentName="p">{`Calendar`}</inlineCode>{` or 2 inputs, representing the start and end date.  `}</p>
    <p>{`Associated actions :  `}</p>
    <ul>
      <li parentName="ul">{`blurStartDate : Blur the associated input's focus`}</li>
      <li parentName="ul">{`blurEndDate : Blur the associated input's focus`}</li>
      <li parentName="ul">{`focusStartDate : Focus the associated input`}</li>
      <li parentName="ul">{`focusEndDate : Focus the associated input`}</li>
      <li parentName="ul">{`focusLock : Enable/Disable the focus lock, so that tabbing behaviour links both input and `}<inlineCode parentName="li">{`Calendar`}</inlineCode></li>
    </ul>
    <h2 {...{
      "id": "reading-state"
    }}>{`Reading State`}</h2>
    <p>{`Providing an `}<inlineCode parentName="p">{`onStateChange`}</inlineCode>{` callback to the `}<inlineCode parentName="p">{`CalendarProvider`}</inlineCode>{` enables you to respond to state change.`}</p>
    <p>{`In this example, `}<inlineCode parentName="p">{`state`}</inlineCode>{` and `}<inlineCode parentName="p">{`changes`}</inlineCode>{` are logged to the console.`}</p>
    <Playground __position={1} __code={'() => {\n  // import { Calendar } from \"@use-date-input/core\";\n  // import { adapter as dateAdapter } from \"@use-date-input/date-fns-adapter\";\n  function handleStateChange(newState, changes) {\n    console.log(\'new state\', newState, changes)\n  }\n  return <Calendar adapter={dateAdapter} onStateChange={handleStateChange} />\n}'} __scope={{
      props,
      DefaultLayout,
      useRef,
      useState,
      useDocs,
      Link,
      Playground,
      styled,
      calendarActions,
      calendarReducer,
      createDateAPI,
      Calendar,
      CalendarProvider,
      Day,
      useCalendarDispatch,
      useCalendarState,
      singleDateReducer,
      Root,
      makeStyles,
      List,
      ListItem,
      ListItemText,
      dateAdapter,
      getDay,
      eachDayOfInterval,
      sampleTheme,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        // import { Calendar } from "@use-date-input/core";
        // import { adapter as dateAdapter } from "@use-date-input/date-fns-adapter";
        function handleStateChange(newState, changes) {
          console.log('new state', newState, changes);
        }

        return <Calendar adapter={dateAdapter} onStateChange={handleStateChange} mdxType="Calendar" />;
      }}
    </Playground>
    <h2 {...{
      "id": "changing-state"
    }}>{`Changing State`}</h2>
    <p>{`In addition to the reducers, state can be modified via the `}<inlineCode parentName="p">{`useCalendarDispatch`}</inlineCode>{` hook or an `}<inlineCode parentName="p">{`actions`}</inlineCode>{` ref.`}</p>
    <h3 {...{
      "id": "usecalendardispatch"
    }}>{`useCalendarDispatch`}</h3>
    <p>{`Actions can be dispatched via an API returned by the `}<inlineCode parentName="p">{`useCalendarDispatch`}</inlineCode>{` hook.  `}</p>
    <p><inlineCode parentName="p">{`useCalendarDispatch`}</inlineCode>{` can be used in any child of `}<inlineCode parentName="p">{`CalendarProvider`}</inlineCode>{`.  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const {
    dispatch,
    mouseClickOutside,
    navigateNext,
    navigatePrevious,
    selectDate,
    setAnimating,
    setEnableKeyboardNavigation,
    setKeyboardCursor,
    setMouseCursor,
    setEndDate,
    setStartDate,
    setOpen,
    setKeyPress,
    setVisibleFromDate
} = useCalendarDispatch();
`}</code></pre>
    <p>{`Use `}<inlineCode parentName="p">{`dispatch`}</inlineCode>{` or use the helper functions, which wrap the dispatch method, they are equivalent.  `}</p>
    <p>{`Refer to the `}<a parentName="p" {...{
        "href": "https://mark-tate.github.io/use-date-input/useCalendarDispatch"
      }}>{`useCalendarDispatch`}</a>{` docs for examples.`}</p>
    <h3 {...{
      "id": "actions-ref"
    }}>{`Actions Ref`}</h3>
    <p>{`Providing an `}<inlineCode parentName="p">{`actions`}</inlineCode>{` ref to the `}<inlineCode parentName="p">{`CalendarProvider`}</inlineCode>{` enables you to control the Component state externally using either the helper functions or the dispatcher itself.`}</p>
    <p>{`The ref will be assigned the `}<inlineCode parentName="p">{`useCalendarDispatch`}</inlineCode>{` API that enables you to modify the state.`}</p>
    <p>{`An `}<inlineCode parentName="p">{`actions`}</inlineCode>{` ref can be used anywhere, even outside the `}<inlineCode parentName="p">{`CalendarProvider`}</inlineCode>{` hierachy and unlike the hook `}<inlineCode parentName="p">{`useCalendarDispatch`}</inlineCode>{` can be called, as and when needed.  `}</p>
    <p>{`In this example, the date range is created by setting the endDate, upon selection of the start date. `}</p>
    <Playground __position={2} __code={'() => {\n  // import { useRef, useState } from \"react\";\n  // import { Calendar, CalendarProvider } from \"@use-date-input/core\";\n  // imprt dateAdapter from \"@use-date-input/date-fns-adapter\";\n  const [storeDate, setStoreDate] = useState()\n  const actions = useRef()\n  function handleCalendarChange(value) {\n    const [rangeStart, rangeEnd] = value\n    const { setStartDate, setEndDate, dateAPI } = actions.current\n    if (!dateAPI.isSameDay(storeDate, rangeStart)) {\n      const endDate = dateAPI.addWeeks(rangeStart, 1)\n      setEndDate(endDate)\n      setStoreDate(rangeStart)\n    }\n  }\n  return (\n    <CalendarProvider\n      actions={actions}\n      adapter={dateAdapter}\n      allowRange\n      onCalendarChange={handleCalendarChange}\n    >\n      <Calendar />\n    </CalendarProvider>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      useRef,
      useState,
      useDocs,
      Link,
      Playground,
      styled,
      calendarActions,
      calendarReducer,
      createDateAPI,
      Calendar,
      CalendarProvider,
      Day,
      useCalendarDispatch,
      useCalendarState,
      singleDateReducer,
      Root,
      makeStyles,
      List,
      ListItem,
      ListItemText,
      dateAdapter,
      getDay,
      eachDayOfInterval,
      sampleTheme,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        // import { useRef, useState } from "react";
        // import { Calendar, CalendarProvider } from "@use-date-input/core";
        // imprt dateAdapter from "@use-date-input/date-fns-adapter";
        const [storeDate, setStoreDate] = useState();
        const actions = useRef();

        function handleCalendarChange(value) {
          const [rangeStart, rangeEnd] = value;
          const {
            setStartDate,
            setEndDate,
            dateAPI
          } = actions.current;

          if (!dateAPI.isSameDay(storeDate, rangeStart)) {
            const endDate = dateAPI.addWeeks(rangeStart, 1);
            setEndDate(endDate);
            setStoreDate(rangeStart);
          }
        }

        return <CalendarProvider actions={actions} adapter={dateAdapter} allowRange onCalendarChange={handleCalendarChange} mdxType="CalendarProvider">
            <Calendar mdxType="Calendar" />
        </CalendarProvider>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      